import { render, staticRenderFns } from "./browsinghistory.vue?vue&type=template&id=575b2b42&scoped=true&"
import script from "./browsinghistory.vue?vue&type=script&lang=js&"
export * from "./browsinghistory.vue?vue&type=script&lang=js&"
import style0 from "./browsinghistory.vue?vue&type=style&index=0&id=575b2b42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b2b42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('575b2b42')) {
      api.createRecord('575b2b42', component.options)
    } else {
      api.reload('575b2b42', component.options)
    }
    module.hot.accept("./browsinghistory.vue?vue&type=template&id=575b2b42&scoped=true&", function () {
      api.rerender('575b2b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/myinfo/browsinghistory.vue"
export default component.exports